const setResumeEducation = (education) => ({
    type: 'SET_RESUME_EDUCATION',
    education,
});

export default setResumeEducation;
